var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
import { prepareAnalytics } from './prepare-analytics';
var AnalyticsEventEmitter = /** @class */ (function () {
    function AnalyticsEventEmitter() {
        var _this = this;
        this._initialized = false;
        this._prefix = '';
        this.init = function (_a) {
            var prefix = _a.prefix, _b = _a.counterId, counterId = _b === void 0 ? 7 : _b;
            prepareAnalytics(window, document, 'script', 'https://a.wb.ru/sdk/sdk.js', 'wba');
            window.wba('init', { counterId: counterId });
            _this._initialized = true;
            if (prefix) {
                _this._prefix = prefix;
            }
            console.log('@analytics init done');
        };
        this.getIsInitialized = function () { return _this._initialized; };
        this._getCustomEvent = function (name) {
            if (_this._prefix) {
                return _this._prefix + "-" + name;
            }
            return name;
        };
        this.sendEvent = function (_a) {
            var name = _a.name, params = _a.params, customEvent = _a.customEvent, projectName = _a.projectName;
            if (!_this._initialized) {
                return;
            }
            var formattedName = customEvent ? _this._getCustomEvent(name) : name;
            var formattedParams = projectName ? __assign(__assign({}, params), { projectName: projectName }) : params;
            window.wba(formattedName, formattedParams);
        };
    }
    return AnalyticsEventEmitter;
}());
export var analyticsEventEmitter = new AnalyticsEventEmitter();
